// Constants
import { TABLE_LIST } from "constants/navigation/info";

// Hooks
import useTranslate from "hooks/useTranslate";
import useFormatNumber from "../../../hooks/useFormatNumber";

import "./styles.sass";

const TableBonus = () => {
  const t = useTranslate();
  const formatNumber = useFormatNumber();
  return (
    <table className="TableBonus">
      <tbody className="TableBonus__body">
        <tr className="TableBonus__row">
          <td className="TableBonus__currency_first">
            {t("info.promo.welcome.table.currency")}
          </td>
          <td className="TableBonus__cell_first">
            {t("info.promo.welcome.table.min")}
          </td>
          <td className="TableBonus__cell_first">
            {t("info.promo.welcome.table.max")}
          </td>
        </tr>
        {TABLE_LIST.map((item) => {
          return (
            <tr key={item.currency} className="TableBonus__row">
              <td className="TableBonus__currency">{item.currency}</td>
              <td className="TableBonus__cell">{formatNumber(item.min, 0)}</td>
              <td className="TableBonus__cell">{formatNumber(item.max, 0)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default TableBonus;
